// extracted by mini-css-extract-plugin
module.exports = {"discovered":"TargetLabels_discovered__2eSl4"};